import React from 'react'
import { Box } from '@mui/material'

import theme from 'assets/theme'

function Card({ children, header }) {
  return (
    <>
      {header && <>{header}</>}
      <Box
        sx={{
          backgroundColor: '#fff',
          // padding: '20px',
          borderRadius: header
            ? { xs: '0px 0px 12px 12px', md: '0px 0px 20px 20px' }
            : { xs: '12px', md: '20px' },
          boxShadow: header
            ? 'none'
            : `
              0px 4px 25px -8px rgba(0, 0, 0, 0.15),
              0px -2px 12px -6px rgba(0, 0, 0, 0.08)
            `,
          textAlign: 'left',
        }}
      >
        <Box
          sx={{
            // backgroundColor: '#B8C2F21A',
            borderRadius: '10px',
          }}
        >
          {children}
        </Box>
      </Box>
    </>
  )
}

export default Card
